import { styled } from "goober";
import type { ComponentProps } from "react";
import { CodeEditor } from "../CodeEditor";

const EditorFrame = styled("div")`
  height: 100%;
  overflow: hidden;

  & .cm-editor,
  & .cm-scroller {
    height: 100%;
  }

  && .cm-editor,
  && .cm-content,
  && .cm-line,
  && .cm-scroller {
    font-size: 12px;
    line-height: 18px;
  }

  && .cm-content {
    padding: 24px;
  }
`;

export function SkillFileEditor(props: ComponentProps<typeof CodeEditor>) {
  return (
    <EditorFrame>
      <CodeEditor showLineNumbers={false} {...props} />
    </EditorFrame>
  );
}
